import Popup from 'components/popup';
import Slider from 'components/slider';

// Слайдер вакансий с кликабельными элементами и вызовом попапов
const vacancySliderWrap = document.querySelector('.j-slider-vacancy');

if (vacancySliderWrap) {
    const sliderVacancy = new Slider();

    sliderVacancy.init({
        slider       : vacancySliderWrap,
        dots         : false,
        thumbnails   : false,
        arrow        : true,
        counter      : true,
        arrowPosition: 'caption',
        modify       : 'action_slide',
        slideVisible : 3,
        responsive   : {
            0   : 1.15,
            670 : 1.5,
            960 : 2,
            1280: 3
        }
    });
}

// Попапы вакансий
const vacancyPopupBtn = Array.from(document.querySelectorAll('.j-vacancy-popup'));

const initVacancyPopup = (buttons) => {
    if (buttons) {
        const popupOptions = {
            openButtons         : buttons,
            closeButtonAriaLabel: 'Закрыть попап вакансии',
            template            : 'classic',
            templateContent     : 'vacancy'
        };

        const popupCallback = new Popup(popupOptions);

        popupCallback.init();
    }
};

if (vacancyPopupBtn.length) {
    initVacancyPopup(vacancyPopupBtn);
}
